import { scaffoldList } from "common/scaffolding/reducers/scaffoldList";
import { TypeKeys as EditTypeKeys } from "./edit";
import { Promotion } from "../types";

enum TypeKeys {
    LOADING = "PROMOTIONS/LIST_BEGIN",
    LOADED = "PROMOTIONS/LIST_SUCCESS",
    FAILED = "PROMOTIONS/LIST_FAILURE",
    RELOAD = "PROMOTIONS/LIST_RELOAD",
}
const list = scaffoldList<Promotion, typeof TypeKeys, typeof EditTypeKeys>(TypeKeys, EditTypeKeys);
const { createAction, reducer } = list;

export type State = ReturnType<typeof list.reducer>;
export { createAction, reducer };
